"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hourglass = void 0;
var hourglass_1 = require("./hourglass");
Object.defineProperty(exports, "Hourglass", { enumerable: true, get: function () { return hourglass_1.Hourglass; } });
//# sourceMappingURL=index.js.map